const RADIUS_MARKS_EVENT_TICKET = [10, 200, 400, 600, 800, 1000] as const;
const RADIUS_MARKS_DEFAULT = [10, 20, 40, 60, 80, 100] as const;

export const EVENT_TICKET_FIRST_SEGMENT_STOPS = [
  10, 50, 100, 150, 200,
] as const;

export function getAppleRadiusSliderMarks(
  templateType: string
): readonly number[] {
  return templateType === 'eventTicket'
    ? RADIUS_MARKS_EVENT_TICKET
    : RADIUS_MARKS_DEFAULT;
}

export function getAppleRadiusMinMax(templateType: string): {
  min: number;
  max: number;
} {
  const marks = getAppleRadiusSliderMarks(templateType);
  return { min: marks[0], max: marks[marks.length - 1] };
}

function nearestInStops(meters: number, stops: readonly number[]): number {
  let best = stops[0];
  let bestD = Infinity;
  for (const s of stops) {
    const d = Math.abs(s - meters);
    if (d < bestD) {
      bestD = d;
      best = s;
    }
  }
  return best;
}

export function snapEventTicketFirstSegmentMeters(meters: number): number {
  return nearestInStops(
    Math.max(10, Math.min(200, meters)),
    EVENT_TICKET_FIRST_SEGMENT_STOPS
  );
}

export function snapAppleRadiusMeters(
  meters: number,
  templateType: string
): number {
  const { min, max } = getAppleRadiusMinMax(templateType);
  const clamped = Math.max(min, Math.min(max, meters));

  if (templateType === 'eventTicket') {
    if (clamped <= 200) {
      return snapEventTicketFirstSegmentMeters(clamped);
    }
    const step = 5;
    const stepped = Math.round(clamped / step) * step;
    return Math.max(200, Math.min(max, stepped));
  }

  const step = 5;
  const stepped = Math.round(clamped / step) * step;
  return Math.max(min, Math.min(max, stepped));
}
